import { render, staticRenderFns } from "./selectAsset.vue?vue&type=template&id=8265deb2&scoped=true"
import script from "./selectAsset.vue?vue&type=script&lang=js"
export * from "./selectAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265deb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8265deb2')) {
      api.createRecord('8265deb2', component.options)
    } else {
      api.reload('8265deb2', component.options)
    }
    module.hot.accept("./selectAsset.vue?vue&type=template&id=8265deb2&scoped=true", function () {
      api.rerender('8265deb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/init/selectAsset/selectAsset.vue"
export default component.exports